export function getPercentage (total, amount) {
    return total ? (amount / total) * 100 : 0
}
